/*
 * Collectro wishlist — a lightweight, no-account "save for later" feature.
 * Stores product handles in the browser's localStorage. No app, no backend.
 */
(function () {
  var STORAGE_KEY = 'collectro:wishlist';

  var HEART_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-heart" ' +
    'aria-hidden="true" focusable="false"><path d="M12 20.5s-7.6-4.66-10.06-9.32C.5 8.05 1.9 4.5 5.1 3.4c2.3-.8 ' +
    '4.6.1 6 2.1 1.4-2 3.7-2.9 6-2.1 3.2 1.1 4.6 4.65 3.06 7.78C19.6 15.84 12 20.5 12 20.5z"/></svg>';

  function readHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* localStorage unavailable (private mode, disabled cookies, etc.) — fail silently */
    }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { handles: handles } }));
  }

  function has(handle) {
    return readHandles().indexOf(String(handle)) !== -1;
  }

  function toggle(handle) {
    handle = String(handle);
    var handles = readHandles();
    var index = handles.indexOf(handle);
    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }
    writeHandles(handles);
    return index === -1;
  }

  function updateButtonState(button) {
    var handle = button.getAttribute('data-wishlist-id');
    var active = has(handle);
    var label = active ? 'Remove from wishlist' : 'Add to wishlist';
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', label);
    var span = button.querySelector('.wishlist-heart-label');
    if (span) span.textContent = label;
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-id]').forEach(updateButtonState);
  }

  function updateCountBubble() {
    var bubble = document.getElementById('wishlist-count-bubble');
    if (!bubble) return;
    var count = readHandles().length;
    var span = bubble.querySelector('span[aria-hidden]');
    if (span) span.textContent = count;
    bubble.hidden = count === 0;
  }

  function buildRemoveButtonHtml(handle) {
    return (
      '<button type="button" class="wishlist-heart-button wishlist-remove-button" ' +
      'data-wishlist-id="' + handle.replace(/"/g, '&quot;') + '" aria-pressed="true" ' +
      'aria-label="Remove from wishlist" title="Remove from wishlist">' +
      HEART_SVG +
      '<span class="wishlist-heart-label visually-hidden">Remove from wishlist</span></button>'
    );
  }

  function renderWishlistGrid() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var emptyState = document.getElementById('wishlist-empty');
    var handles = readHandles();

    grid.innerHTML = '';

    if (handles.length === 0) {
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;

    var validHandles = [];
    var pending = handles.length;

    handles.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=wishlist-card-render')
        .then(function (response) {
          if (!response.ok) throw new Error('product unavailable');
          return response.text();
        })
        .then(function (html) {
          validHandles.push(handle);
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.innerHTML = html.trim();
          // The wishlist page is the one place a saved product's card shows a
          // (already-active) heart button, so it can be removed directly from
          // this list — card-product.liquid itself never renders one.
          var media = li.querySelector('.card__media');
          if (media) {
            media.insertAdjacentHTML('afterbegin', buildRemoveButtonHtml(handle));
          }
          grid.appendChild(li);
          updateAllButtons();
        })
        .catch(function () {
          /* product no longer exists or is unavailable — dropped from storage below */
        })
        .finally(function () {
          pending -= 1;
          if (pending === 0) {
            if (grid.children.length === 0 && emptyState) emptyState.hidden = false;
            if (validHandles.length !== handles.length) {
              writeHandles(validHandles);
            }
          }
        });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-id]');
    if (!button) return;
    event.preventDefault();
    toggle(button.getAttribute('data-wishlist-id'));
    updateAllButtons();
    updateCountBubble();
  });

  document.addEventListener('wishlist:change', function () {
    updateCountBubble();
    if (document.getElementById('wishlist-grid')) {
      renderWishlistGrid();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    updateCountBubble();
    renderWishlistGrid();
  });

  window.CollectroWishlist = { readHandles: readHandles, has: has, toggle: toggle };
})();
